import React, { useState } from 'react';
import '../Styles/CategorySidebar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faFilter, faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addItem, clearList, removeItem } from '../redux/filterCatagoryListSlice';



const filterCategoryConstant=[  /// constant value of subcatagory filter
  { id: 1, name: 'Electronics' ,subCat:['Mics','Speaker','Accessories','Drone','Keyboard','Gaming','Pencil','Headphone','Camera']},
  {id:2,name:"Mobile",subCat:['Android phone','iphone']},
  {id:3,name:"Lifestyle",subCat:['Perfume']},
  {id:4,name:"Laptop",subCat:['Laptop']},
  {id:5,name:"Tabs",subCat:['Tabs']},
  {id:6,name:"Watch",subCat:['Watch']},

]



// below one is a reusable component for subcategory filter
const FilterSubCategory = ({name,subCat}) => {

  const [open, setOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
 
  const dispatch = useDispatch();
const items = useSelector((state) => state.filterCatagoryList.items);


    const handleChange =async (event) => {


    if (event.target.checked) {
     dispatch(addItem(event.target.value)); 
      
    } else {
     dispatch(removeItem(event.target.value))
      
    }
    
    
    
  };

  return(
    <div >
     <div
     onClick={()=> setOpen(!open)}
     style={{display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",fontSize:"18px", fontStyle:"bold"}}>
      <p style={{fontSize:"18px",fontWeight:"bold"}}>{name} </p>
      <FontAwesomeIcon icon={open ? faAngleUp : faAngleDown} />
      </div> 

     {open&& <div style={{display:"flex",flexDirection:"column",gap:"7px",paddingLeft:"20px"}}>
        {
         subCat.map((subCat, index) => (
            <div style={{display:"flex",gap:"10px",cursor:"pointer"} }>
              <input type='checkbox'
              value={subCat}
              checked={items.includes(subCat)}
              onChange={ handleChange}
           
              />
             {subCat} 
              </div>
          ))
      }
      </div>}
      

    </div>
  )

}


function Sidebar({ onFilterChange, isOpen, setIsOpen,mood }) {
  const [priceDropDown, setPriceDropDown] = useState(true);
  const [ratingFilter, setRatingFilter] = useState(true);

  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [selectedRatings, setSelectedRatings] = useState([]);
  const [filterCategory, setFilterCategory] = useState([]);

  const items = useSelector((state) => state.filterCatagoryList.items);
  const dispatch = useDispatch();

  const handlePriceDropDown = () => setPriceDropDown(!priceDropDown);
  const handleRatingFilter = () => setRatingFilter(!ratingFilter);

  const handleRatingChange = (value) => {
    setSelectedRatings(prev =>
      prev.includes(value) ? prev.filter((r) => r !== value) : [...prev, value]
    );
  };

  const handleApplyFilters = () => {
    onFilterChange({
      min_price: minPrice,
      max_price: maxPrice,
      slug: [...items],
      rating: selectedRatings,
    });
    setIsOpen(false);
    console.log(items);
    
  };
  
  const handleClearFilters = () => {
    dispatch(clearList);
  }
 

  return (
    <>
      {/* Backdrop */}
      {isOpen && mood==="mobile"&& <div className="sidebar-backdrop open" onClick={() => setIsOpen(false)} />}

      {/* Sidebar */}
      <div className={` ${mood==="mobile"?"sidebar":"desktop-sidebar"}  ${isOpen ? 'open' : ''} `}>
      {mood==="mobile"&&  <button className="close-btn" onClick={() => setIsOpen(false)}>✕</button>}

        <div className='Sidebar__title'>
          <FontAwesomeIcon icon={faFilter} />
          <span>Filter</span>
        </div>

        {/*<div
        onClick={handleClearFilters}
        style={{padding:"20px",backgroundColor:"blue"}}>clear</div>
        */}

        {/* Price Filter */}
        <div className='Sidebar_filter_title'>
          <div onClick={handlePriceDropDown} className="Sidebar__toggle">
            <span>Price</span>
            <FontAwesomeIcon icon={priceDropDown ? faAngleUp : faAngleDown} />
          </div>
          {priceDropDown && (
            <div className='Sidebar_filter_input'>
              <input
                type='number'
                placeholder='Min Price'
                value={minPrice}
                onChange={(e) => setMinPrice(e.target.value)}
              />
              <span>to</span>
              <input
                type='number'
                placeholder='Max Price'
                value={maxPrice}
                onChange={(e) => setMaxPrice(e.target.value)}
              />
              <button className='btn btn-success w-100' onClick={handleApplyFilters}>
                Show Products
              </button>
            </div>
          )}
          <hr />
        </div>

        {/* Rating Filter */}
        <div className='Sidebar_filter_title'>
          <div onClick={handleRatingFilter} className="Sidebar__toggle">
            <span>Ratings</span>
            <FontAwesomeIcon icon={ratingFilter ? faAngleUp : faAngleDown} />
          </div>
          {ratingFilter && (
            <form>
              {[5, 4, 3, 2, 1].map(r => (
                <div key={r} className='Sidebar_filter_input'>
                  <label style={{display:"flex"}}>
                    <input
                      type='checkbox'
                      value={r}
                      checked={selectedRatings.includes(r)}
                      onChange={() => handleRatingChange(r)}
                      style={{width:"20%",padding:"20px",height:"20px"}}
                    />
                    <span style={{display:"flex",alignItems:"center",gap:"3px",fontSize:"16px"}}>
                      <span>{r}</span>
                      <FontAwesomeIcon icon={faStar} color='tomato' />
                      <span>& above</span>
                    </span>
                      
                  </label>
                </div>
              ))}
              
            </form>
          )}
          <hr />
        </div>

        {/* Category filter */}
          <div  className='Sidebar_filter_title'>
            {filterCategoryConstant.map((category, id)=>(
              <div key={category.id}>
               <FilterSubCategory  name={category.name} subCat={category.subCat} />
               <hr/>
              </div>
            )) }

          </div>

      </div>
    </>
  );
}

export default Sidebar;
